import axios, { AxiosHeaders } from 'axios';
import { fetchAuthSession }   from 'aws-amplify/auth';

const apiAxios = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:8080"
});

apiAxios.interceptors.request.use(
    async (config) => {
        try {
            const { tokens } = await fetchAuthSession();
            const rawToken  = tokens?.idToken?.toString();
            if (rawToken) {
                // Turn whatever headers you already have into an AxiosHeaders
                const headers = new AxiosHeaders(config.headers);
                // Use the `set` method
                headers.set('Authorization', `Bearer ${rawToken}`);
                // Re-assign the headers field back to your config
                config.headers = headers;
            }
        } catch (err) {
            console.warn('fetchAuthSession failed', err);
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default apiAxios;